import { t } from 'ttag';

import { ConfirmActionModal, ConfirmActionModalProps } from '@ui/ConfirmActionModal';
import { Title } from '@ui/Title';

import s from './SafePaymentMethodRequiredErrorModal.sss';

type Props = Omit<
ConfirmActionModalProps,
'confirmButtonText' | 'cancelButtonText'
>;

export const SafePaymentMethodRequiredErrorModal: React.FC<Props> = ({
  ...props
}) => (
  <ConfirmActionModal
    {...props}
    confirmButtonText={t`Обрати карту/рахунок`}
    cancelButtonText={t`Відміна`}
  >
    <Title
      className={s.title}
      type='h3'
      bold={false}
    >
      {t`Безпечна оплата`}
    </Title>

    <p className={s.text}>
      {t`Щоб увімкнути Безпечну оплату, оберіть спосіб зарахування коштів (на картку фізичної особи, на рахунок ФОП/ТОВ)`}
    </p>
  </ConfirmActionModal>
);
